import { useIntl } from 'react-intl';

import { SignUpSlide } from '../reg-guide-page/sign-up-slide';
import { ReactNode } from 'react';
import { useStyles } from './reg-guide-page.styles';
import { RegSteps } from '../reg-guide-page/reg-steps';
import { Benefits } from './benefits';
import { adultSteps, childSteps } from './reg-guide-page.items';
import { Page } from '../page/page';

export const RegGuidePageNew = (): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Page title={intl.formatMessage({ id: 'regGuide.title' })}>
      <SignUpSlide
        title="regGuide.banner.title"
        description="regGuide.banner.description"
        isDark
      />
      <div className={classes.root}>
        <h2
          id="adult"
          className={classes.title}
          data-testid="save-fitting"
        >{intl.formatMessage(
          { id: 'regGuide.content.title' },
          {
            sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
            span: (chunks: ReactNode) => <span className={classes.newLine}>{chunks}</span>,
            strong: (chunks: ReactNode) => <strong className={classes.emphasis}>{chunks}</strong>,
          },
        )}</h2>
        <div className={classes.stepsWrapper}>
          <span aria-hidden="true" className={classes.arrow} />
          <RegSteps steps={adultSteps} />
        </div>
      </div>
      <h2 className={classes.subtitle} id="child" tabIndex={-1}>
        {intl.formatMessage(
          { id: 'regGuide.subtitle' },
          {
            sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
            span: (chunks: ReactNode) => <span className={classes.emphasisChild}>{chunks}</span>,
          },
        )}
      </h2>
      <div className={classes.stepsWrapperChild}>
        <RegSteps isChild steps={childSteps} />
      </div>
      <Benefits />
    </Page>
  );
};
